import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sigma",
  "use": "icon-sigma-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-sigma\"><path d=\"M23 10c.552 0 1-.537 1-1.2V5.2c0-.663-.448-1.2-1-1.2H9.002c-.389 0-.742.268-.907.69s-.112.92.137 1.278L15.23 16l-7 10.032a1.4 1.4 0 0 0-.136 1.278c.165.422.518.69.907.69H23c.552 0 1-.537 1-1.2v-3.6c0-.663-.448-1.2-1-1.2s-1 .537-1 1.2V26H10.912l6.359-9.232a1.39 1.39 0 0 0 0-1.536l-6.537-9.264L22 6v2.8c0 .663.448 1.2 1 1.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol